import { ModalHeader, ModalTitle } from '../../../../../ui/modal';
import Entity from '../../../../entity/Entity';
import PropTypes from 'prop-types';

const HeaderTitle = ({ title, namespace, data = {} }) => (
    <ModalHeader>
        <ModalTitle>
            <Entity namespace={namespace} entity={title} data={data} />
        </ModalTitle>
    </ModalHeader>
);

HeaderTitle.propTypes = {
    title: PropTypes.string.isRequired,
    namespace: PropTypes.string,
    data: PropTypes.object
};

export default HeaderTitle;